export class UtilsDate {
  public static AddMinutos(fecha: Date, minutos: number): Date {
    //1000 milisegundos en un segundo * 60 segundos en un minuto * minutos.
    return new Date(fecha.getTime() + 1000 * 60 * minutos);
  } //https://stackoverflow.com/questions/42261302/how-to-add-a-day-to-a-date-in-typescript
  public static AddHoras(fecha: Date, horas: number): Date {
    //1000 milisegundos en un segundo * 60 segundos en un minuto * horas.
    return new Date(fecha.getTime() + 1000 * 60 * 60 * horas);
  }
  public static AddDias(fecha: Date, dias: number): Date {
    //1000 milisegundos en un segundo * 60 segundos en un minuto * 60 minutos en una hora * 24 horas* dias
    return new Date(fecha.getTime() + 1000 * 60 * 60 * 24 * dias);
  }

  public static formatDateToVueTify(fecha: Date, withTime: boolean) {
    return withTime
      ? `${fecha.getFullYear()}-${fecha.getMonth() +
          1}-${fecha.getDate()} ${fecha.getHours()}:${fecha.getMinutes()}`
      : `${fecha.getFullYear()}-${fecha.getMonth() + 1}-${fecha.getDate()}`;
  }

  public static formatDateToVueTifyDDMMAAAA(fecha: Date, withTime: boolean) {
    return withTime
      ? `${fecha.getDate()}/${fecha.getMonth() +
          1}/${fecha.getFullYear()} ${fecha.getHours()}:${fecha.getMinutes()}`
      : `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
  }

  public static FormatDateBack(fecha: any) {
    let date = new Date(fecha);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    if (month < 10) {
      return `${day}/0${month}/${year}`;
    }
    return `${day}/${month}/${year}`;
  }
  public static dayOfWeek(month: number, year: number, day: number) {
    const options = { weekday: "long" };
    let dia_semana_español = new Date(
      Date.UTC(year, month, day, 3, 0, 0)
    ).toLocaleDateString("es-ES", options);
    let dia_index = 0;
    let dia_idioma_pc = new Date(
      Date.UTC(year, month, day, 3, 0, 0)
    ).toLocaleDateString(undefined, options);
    switch (dia_semana_español.toLowerCase()) {
      case "lunes":
        dia_index = 1;
        break;
      case "martes":
        dia_index = 2;
        break;
      case "miércoles":
        dia_index = 3;
        break;
      case "jueves":
        dia_index = 4;
        break;
      case "viernes":
        dia_index = 5;
        break;
      case "sábado":
        dia_index = 6;
        break;
      case "domingo":
        dia_index = 7;
        break;
    }

    return { dayIndex: dia_index, name_day: dia_idioma_pc };
  }
  public static FormatToDateTime(date: any) {
    var fecha = new Date(date);
    if (isNaN(fecha.getTime())) {
      return "";
    }
    if (fecha.getFullYear() === 0) {
      return "";
    }
    return (
      fecha.getUTCDate().toString() +
      "/" +
      (fecha.getUTCMonth() + 1).toString() +
      "/" +
      fecha.getUTCFullYear() +
      " " +
      fecha.getHours() +
      ":" +
      fecha.getMinutes() +
      ":" +
      fecha.getSeconds()
    );
  }

  //Libreria para fechas
  //https://github.com/datejs/Datejs

  public static convert(d: any) {
    // Converts the date in d to a date-object. The input can be:
    //   a date object: returned without modification
    //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
    //   a number     : Interpreted as number of milliseconds
    //                  since 1 Jan 1970 (a timestamp)
    //   a string     : Any format supported by the javascript engine, like
    //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
    //  an object     : Interpreted as an object with year, month and date
    //                  attributes.  **NOTE** month is 0-11.
    return d.constructor === Date
      ? d
      : d.constructor === Array
      ? new Date(d[0], d[1], d[2])
      : d.constructor === Number
      ? //@ts-ignore
        new Date(d)
      : d.constructor === String
      ? //@ts-ignore
        new Date(d)
      : typeof d === "object"
      ? new Date(d.year, d.month, d.date)
      : NaN;
  }
  public static daysinMouth(month: number, year: number) {
    // Aqui enero es 1
    //Eldia 0 es el ultimo dia del mes anterior
    return new Date(year, month, 0).getDate();
  }

  public static NameMouth(month: number) {
    const options = { month: "long" };
    return new Date(Date.UTC(2020, month, 1, 3, 0, 0)).toLocaleDateString(
      undefined,
      options
    );
  }
}
